module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": false
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("营销工具")])]), _vm._v(" "), _c('section', {
    staticClass: "list-cont"
  }, [_c('div', [_c('ul', {
    staticClass: "fx fx-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'promotionList'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-full-cut"
  }), _vm._v(" "), _c('p', [_vm._v("满减活动管理")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'redPacketList'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-red-packet"
  }), _vm._v(" "), _c('p', [_vm._v("裂变红包管理")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'couponList'
      },
      "tag": "li"
    }
  }, [_c('span', {
    staticClass: "icon-coupon"
  }), _vm._v(" "), _c('p', [_vm._v("优惠券管理")])])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-9ace6fe0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/marketing/Index.vue
// module id = 877
// module chunks = 0